module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productsList.length > 0),
      expression: "productsList.length > 0"
    }],
    staticClass: "ui grid centered container segments dimmable",
    attrs: {
      "id": "container"
    }
  }, _vm._l((_vm.productsList), function(product) {
    return _c('li', {
      staticClass: "sixteen wide column ui segment grid"
    }, [_c('a', {
      staticClass: "ui left corner label mobile below being link light-yellow removebtn",
      on: {
        "click": function($event) {
          return _vm.removeSelectedProduct(product.id)
        }
      }
    }, [_c('i', {
      staticClass: "trash icon"
    })]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "two wide column mobile below hidden"
    }, [_c('button', {
      staticClass: "ui big icon button light-yellow removebtn",
      attrs: {
        "title": "CHECK_REMOVE"
      },
      on: {
        "click": function($event) {
          return _vm.removeSelectedProduct(product.id)
        }
      }
    }, [_c('i', {
      staticClass: "trash outline icon"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "two wide column mobile below hidden"
    }, [_c('img', {
      staticClass: "ui centered medium image",
      attrs: {
        "src": product.image
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "sixteen wide mobile six wide tablet six wide computer column"
    }, [_c('h4', {
      staticClass: "ui header"
    }, [_vm._v(_vm._s(product.name))]), _vm._v(" "), (product.attrs || (product.globalwifi && product.globalwifi.itineraryList)) ? _c('ul', {
      staticClass: "ui cell list"
    }, [(product.globalwifi && product.globalwifi.itineraryList) ? [_c('li', {
      staticClass: "item"
    }, [_vm._v("\n                                高速流量：" + _vm._s(product.globalwifi.flow_type) + "\n                            ")]), _vm._v(" "), _vm._l((product.globalwifi.itineraryList), function(itinerary) {
      return _c('li', {
        staticClass: "item"
      }, [_vm._v("\n                                " + _vm._s(itinerary.countryName) + ": " + _vm._s(itinerary.startTime) + "~" + _vm._s(itinerary.endTime) + "\n                            ")])
    })] : _vm._e(), _vm._v(" "), _vm._l((product.attrs), function(attr) {
      return (!_vm.thisOptionsValuesIdIsException(attr.options_values_id)) ? _c('li', {
        staticClass: "item"
      }, [_vm._v("\n    " + _vm._s(attr.products_options_name) + ": "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(attr.products_options_values_name)
        }
      })]) : _vm._e()
    })], 2) : _vm._e(), _vm._v(" "), _c('a', {
      attrs: {
        "href": product.link
      }
    }, [_vm._v(_vm._s(_vm.lang.say('BUY_DIFFERENT_SPECIFICATIONS')))])]), _vm._v(" "), _c('div', {
      staticClass: "sixteen wide mobile two wide tablet two wide computer column ui form"
    }, [_c('div', {
      staticClass: "field",
      class: {
        'error': _vm.shouldShoeQtyError(product)
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (product.quantity >= 10),
        expression: "product.quantity >= 10"
      }],
      staticClass: "ui fluid input"
    }, [_c('input', {
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": product.quantity
      },
      on: {
        "change": function($event) {
          return _vm.updateModelQuantity($event, product.id)
        }
      }
    })]), _vm._v(" "), _c('select', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (product.quantity < 10),
        expression: "product.quantity < 10"
      }],
      staticClass: "ui compact fluid dropdown",
      domProps: {
        "value": product.quantity
      },
      on: {
        "change": function($event) {
          return _vm.updateModelQuantity($event, product.id)
        }
      }
    }, [_vm._l((9), function(num) {
      return _c('option', {
        domProps: {
          "value": num
        }
      }, [_vm._v("\n                " + _vm._s(num) + "\n            ")])
    }), _vm._v(" "), _c('option', {
      attrs: {
        "value": "10"
      }
    }, [_vm._v("10+")])], 2), _vm._v(" "), _c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.shouldShoeQtyError(product)),
        expression: "shouldShoeQtyError(product)"
      }]
    }, [_vm._v(_vm._s(_vm.lang.say('ERROR_RENTAL_QUANTITY_INSUFFICIENT')))])])]), _vm._v(" "), _c('div', {
      staticClass: "sixteen wide mobile four wide computer column right aligned"
    }, [_c('div', {
      staticClass: "ui list"
    }, [(product.priceToShow.others) ? _c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "header"
    }, [_vm._v("\n                " + _vm._s(_vm.lang.say('TEXT_RENTAL_OTHERS_FEE')) + "\n            ")]), _vm._v("\n            " + _vm._s(product.priceToShow.others) + "\n        ")]) : _vm._e(), _vm._v(" "), (product.priceToShow.desposit) ? _c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "header"
    }, [_vm._v("\n                " + _vm._s(_vm.lang.say('TEXT_RENTAL_DEPOSIT')) + "\n            ")]), _vm._v("\n            " + _vm._s(product.priceToShow.desposit) + "\n        ")]) : _vm._e(), _vm._v(" "), (product.priceToShow.setting_charge) ? _c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "header"
    }, [_vm._v("\n                " + _vm._s(_vm.lang.say('TEXT_RENTAL_SETTING_FEE')) + "\n            ")]), _vm._v("\n            " + _vm._s(product.priceToShow.setting_charge) + "\n        ")]) : _vm._e(), _vm._v(" "), (product.priceToShow.daily_rate) ? _c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "header"
    }, [_vm._v("\n                " + _vm._s(_vm.lang.say('TEXT_RENTAL_DAILY_RATE')) + "\n            ")]), _vm._v("\n            " + _vm._s(product.rental.rental_days) + " （" + _vm._s(_vm.lang.say('TEXT_RENTAL_DAYS')) + "）x " + _vm._s(product.priceToShow.daily_rate) + " x " + _vm._s(product.quantity) + " ≒ " + _vm._s(product.priceToShow.final_rate_price) + "\n        ")]) : _vm._e(), _vm._v(" "), (product.priceToShow.discount) ? _c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "header"
    }, [_vm._v("\n                " + _vm._s(_vm.lang.say('TEXT_RENTAL_DISCOUNT')) + "\n            ")]), _vm._v("\n            " + _vm._s(product.priceToShow.discount * 100) + "% off\n        ")]) : _vm._e(), _vm._v(" "), (product.priceToShow.total_daily_rate) ? _c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "header"
    }, [_vm._v("\n                " + _vm._s(_vm.lang.say('TEXT_TOTAL_RENTAL_DAILY_RATE')) + "\n            ")]), _vm._v("\n            " + _vm._s(product.priceToShow.total_daily_rate) + "\n        ")]) : _vm._e(), _vm._v(" "), (typeof product.priceToShow === 'object') ? _c('div', {
      staticClass: "ui divider"
    }) : _vm._e(), _vm._v(" "), (typeof product.priceToShow === 'object') ? _c('div', {
      staticClass: "item"
    }, [_c('span', {
      staticClass: "price"
    }, [_vm._v("\n                                " + _vm._s(product.priceToShow.final_price) + "\n                            ")])]) : _vm._e(), _vm._v(" "), (typeof product.priceToShow === 'string') ? _c('div', {
      staticClass: "item"
    }, [_c('span', {
      staticClass: "price"
    }, [_vm._v("\n                                " + _vm._s(product.priceToShow) + "\n                            ")])]) : _vm._e()])])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-120cdb97!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductsList.vue
// module id = 373
// module chunks = 0